import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b82d468"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_2 = { class: "meeting-cta-text ion-text-center" }
const _hoisted_3 = { class: "ion-text-uppercase" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-ellipsis" }, null, -1))
const _hoisted_5 = {
  class: "meeting-cta-enter",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Play", -1))
const _hoisted_8 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Meetings", -1))
const _hoisted_10 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Training", -1))
const _hoisted_12 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Pressroom", -1))
const _hoisted_14 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Ranking", -1))
const _hoisted_16 = { class: "details-box ranking shadow ion-text-center menu-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-ellipsis" }, "Rules", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding container-background",
        style: _normalizeStyle(_ctx.homeBackground),
        "padding-left": "",
        "padding-right": ""
      }, {
        default: _withCtx(() => [
          (_ctx.nextJoinableMeeting)
            ? (_openBlock(), _createBlock(_component_ion_card, {
                key: 0,
                class: "meeting-cta meeting-card meeting-cta-clickable",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enterMeeting(_ctx.nextJoinableMeeting)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_content, { class: "meeting-cta-content meeting-cta-content--center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.nextJoinableMeeting.title || _ctx.nextJoinableMeeting.name), 1),
                        _hoisted_4,
                        (_ctx.nextJoinableMeeting.start && _ctx.nextJoinableMeeting.end)
                          ? (_openBlock(), _createBlock(_component_ion_chip, {
                              key: 0,
                              color: "medium",
                              outline: "",
                              class: "meeting-cta-chip"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.calendarOutline }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatLessonDay(_ctx.nextJoinableMeeting.start)) + " " + _toDisplayString(_ctx.formatLessonTime(_ctx.nextJoinableMeeting.start)) + " - " + _toDisplayString(_ctx.formatLessonTime(_ctx.nextJoinableMeeting.end)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.isJoining)
                          ? (_openBlock(), _createBlock(_component_ion_spinner, {
                              key: 0,
                              name: "crescent",
                              class: "join-spinner"
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.isJoining ? 'Apertura in corso...' : 'Entra'), 1),
                        (!_ctx.isJoining)
                          ? (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              icon: _ctx.arrowForwardOutline,
                              class: "meeting-cta-icon"
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_row, { class: "banner margin-home" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('/play')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.gameControllerOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_7
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/lessons')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.libraryOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_9
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "banner margin-home" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/training')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.barbellOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_11
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/pressroom')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.newspaperOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_13
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "banner margin-home" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/ranking')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.podiumOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_15
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "6",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/rules')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ion_icon, {
                      src: _ctx.bookOutline,
                      size: "large"
                    }, null, 8, ["src"]),
                    _hoisted_17
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}